import React from 'react';

export const Background = () => {
    return (
        <div className="fixed inset-0 z-[-1] bg-[#030712] overflow-hidden">
            {/* 1. Base Gradient */}
            <div className="absolute inset-0 bg-gradient-to-b from-[#0f172a] to-[#020617]" />

            {/* 2. Animated Mesh Orbs */}
            {/* Top Left - Cyan/Blue */}
            <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-cyan-500/20 rounded-full blur-[100px] animate-pulse-slow" />

            {/* Bottom Right - Purple/Pink */}
            <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-purple-600/20 rounded-full blur-[100px] animate-pulse-slow delay-1000" />

            {/* Center - Deep Blue */}
            <div className="absolute top-[30%] left-[20%] w-[60%] h-[40%] bg-blue-600/10 rounded-full blur-[80px]" />

            {/* 3. Noise Overlay for Texture */}
            <div className="absolute inset-0 opacity-20" style={{
                backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"%3E%3Cfilter id="noiseFilter"%3E%3CfeTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch"/%3E%3C/filter%3E%3Crect width="100%25" height="100%25" filter="url(%23noiseFilter)" opacity="0.5"/%3E%3C/svg%3E")'
            }} />

            {/* 4. Grid Overlay (Very Subtle) */}
            <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]" />
        </div>
    );
};
